var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsArchiveIcon = function SvgDsArchiveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 7.333a.667.667 0 0 0 0 1.334h4a.667.667 0 1 0 0-1.334z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.333 3.1c0-.976.791-1.767 1.767-1.767h9.8c.976 0 1.767.791 1.767 1.767v.467c0 .56-.26 1.059-.667 1.382v7.273a2.444 2.444 0 0 1-2.444 2.445H4.444A2.444 2.444 0 0 1 2 12.222V4.95a1.76 1.76 0 0 1-.667-1.382zm2 2.233h9.334v6.89c0 .613-.498 1.11-1.111 1.11H4.444a1.11 1.11 0 0 1-1.11-1.11zm10-1.766c0 .239-.194.433-.433.433H3.1a.433.433 0 0 1-.433-.433V3.1c0-.24.194-.433.433-.433h9.8c.24 0 .433.194.433.433z",
    clipRule: "evenodd"
  })));
};
export default SvgDsArchiveIcon;